"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var I18nPriceFormatClientImpl_1 = __importDefault(require("./I18nPriceFormatClientImpl"));
var I18nPriceFormatClientProvider = /** @class */ (function () {
    function I18nPriceFormatClientProvider() {
        this.CONTEXTUAL_PARAMETERS = ["i18n_cx_family", "i18n_priceformat_cx_program", "i18n_priceformat_locale", "i18n_currency", "i18n_priceformat_cx_id", "i18n_priceformat_type"];
        this.STAGE_VERSION_LABEL_NAME = "AcsNewI18nPriceFormatV2";
        this.TABLE_NAME = "acs_NewI18nPriceFormat_V2";
    }
    I18nPriceFormatClientProvider.prototype.createTypeSafeClient = function (configSet) {
        return new I18nPriceFormatClientImpl_1.default(configSet);
    };
    return I18nPriceFormatClientProvider;
}());
exports.default = I18nPriceFormatClientProvider;
